<template>
  <div class="channel">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/changjing/history"
      :key="key"
    >
      <el-table-column slot="changjing" label="渠道名" show-overflow-tooltip width="140">
        <template v-slot="{row}">
          <el-button type="text" @click="detail(row)">{{row.changjing}}</el-button>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
export default {
  components: { CTable },
  data() {
    return {
      fields: [
        {
          prop: 'aboutid',
          placeholder: '渠道id',
          clearable: true
        },
        {
          prop: 'user',
          placeholder: '用户id',
          clearable: true
        },
        {
          prop: 'ip',
          placeholder: 'ip',
          clearable: true
        },
        {
          prop: 'action',
          placeholder: '操作',
          clearable: true
        }
      ],
      columns: [
        { prop: 'usrid', label: '操作者id', width: 140 },
        { prop: 'username', label: '操作者', width: 140 },
        { prop: 'aboutid', label: '渠道id', width: 140 },
        { slot: 'changjing', label: '渠道名' },
        { prop: 'action', label: '操作', 'show-overflow-tooltip': true },
        { prop: 'ip', label: 'ip' },
        { prop: 'time', label: '操作时间' }
      ],
      key: Date.now()
    }
  },
  methods: {
    detail(row) {
      window.open(`/changjing/detail/${row.aboutid}`)
    }
  }
}
</script>

<style lang="scss">
</style>
